import { render, staticRenderFns } from "./MypageIcon.vue?vue&type=template&id=70f4f18a&"
import script from "./MypageIcon.vue?vue&type=script&lang=ts&"
export * from "./MypageIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports